import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'patientsFilter', namespaced: true })
export default class PatientsFilter extends FilterModule {
    constructor(module: PatientsFilter) {
        super(module);
    }
}
